import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    float: 'left',
    zIndex: 1,
    height: '100%',
    minWidth: '175px',
    justifyContent: 'center',
  },
  statusCircle: {
    color: (props) => (props.isTotal ? 'white' : `${props.color}`),
    border: (props) => `5px solid  ${props.color}`,
    cursor: 'pointer',
    width: '110px',
    height: '110px',
    borderRadius: '55px',
    textAlign: 'center',
    backgroundColor: (props) => (props.isTotal ? `${props.color}` : 'rgba(0, 0, 0, 0.6)'),
  },
  statusCircleNumber: {
    paddingTop: '10px',
    fontSize: '30px',
  },
  text: {
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
    fontSize: '14px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
});

const StatusCircle = ({ color, text, number, isTotal }) => {
  const classes = useStyles({ color, isTotal });
  return (
    <div className={classes.container}>
      <div className={classes.statusCircle}>
        <div className={classes.statusCircleNumber}>{number}</div>
        <div className={classes.text}>{text}</div>
      </div>
    </div>
  );
};

export default StatusCircle;
